export default Route => {
  // 产品
  Route.group({ prefix: "/product" }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "product" */ "../views/product/index.vue")
    ).options({
      name: "product",
      props: route => ({ type: parseInt(route.query.type) || 1 }),
      meta: {
        navTransparent: true
      }
    });
    Route.view("/detail/:code(\\d+)", () =>
      import(/* webpackChunkName: "product" */ "../views/product/detail/index.vue")
    ).options({
      name: "product-detail",
      props: true
    });
    Route.view("/index/:type", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/index.vue")
    ).options({
      name: "product_new",
      props: true,
      meta: {
        navTransparent: true
      }
    });
    Route.view("/classify/:type", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/product_group.vue")
    ).options({
      name: "classify",
      props: route => ({ type: parseInt(route.params.type) || "group" }),
    });
    Route.view("/new/detail/:code(\\d+)", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/detail/index.vue")
    ).options({
      name: "product-new-detail",
      props: true,
    });
    Route.view("/new/detail/travelInsurance/:code(\\d+)", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/detail/travelInsurance.vue")
    ).options({
      name: "travel-insurance",
      props: true,
    });
    Route.view("/new/detail/travelInsurance/planSelection", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/detail/lyComponents/planSelection.vue")
    ).options({
      name: "plan-selection",
      props: true,
      meta: {
        hideNav: true
      }
    });
    Route.view("/new/detail/travelInsurance/paySuccess", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/detail/lyComponents/paySuccess.vue")
    ).options({
      name: "pay-success",
      props: true,
      meta: {
        hideNav: true
      }
    });
    Route.view("/new/detail/travelInsurance/policyInquiry", () =>
        import(/* webpackChunkName: "product" */ "../views/product_new/detail/lyComponents/policyInquiry.vue")
    ).options({
      name: "policy-inquiry",
      props: true,
      meta: {
        hideNav: true
      }
    });
    
  });
  Route.group({ prefix: "/jaTs8x4hTs.txt" }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "user" */ "../views/product/sign.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });
};
